/* eslint-disable no-else-return */
export function dayDiffText(diff: number) {
  if (diff < -1) {
    return `${Math.abs(diff)} days ago`
  } else if (diff === -1) {
    return 'yesterday'
  } else if (diff === 0) {
    return 'today'
  } else if (diff === 1) {
    return 'tomorrow'
  } else {
    return `in ${diff} days`
  }
}
